export class Address {
  address?: string;
  civic?: string;
  cap?: string;
  city?: string;
  cityhall?: string;
  province?: string;

  constructor(json?: any) {
    if (!!!json) return;
    this.address = json['indirizzo'];
    this.civic = json['civico'];
    this.cap = json['cap'];
    this.city = json['citta'];
    this.cityhall = json['comune'];
    this.province = json['provincia'];
  }

  toJson(defaultUndefined: boolean = true): any {
    const value = defaultUndefined ? undefined : '';
    if (
      !this.address &&
      !this.civic &&
      !this.cap &&
      !this.city &&
      !this.cityhall &&
      !this.province
    ) {
      return undefined;
    }
    return {
      indirizzo: this.address || value,
      civico: this.civic || value,
      cap: this.cap || value,
      citta: this.city || value,
      comune: this.cityhall || value,
      provincia: this.province || value,
    };
  }

  getFullAddress(): string {
    let tmpString: string = '';
    if (this.address != null) tmpString += this.address!;
    if (this.civic != null) tmpString += `, ${this.civic!}`;
    if (this.city != null) tmpString += ` - ${this.city!}`;
    if (this.cityhall != null) tmpString += ` (Comune di ${this.cityhall!})`;
    if (this.cap != null) tmpString += ` ${this.cap!}`;
    if (this.province != null) tmpString += ` (${this.province!})`;
    return tmpString.trim();
  }
}
